var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OMDatepicker"},[_c('DatePicker',_vm._g(_vm._b({class:_vm.customClasses,attrs:{"clearable":_vm.clearable,"placeholder":_vm.placeholder,"lang":_vm.datePickerLang,"format":_vm.datePickerFormat,"data-cy":_vm.cyId,"not-before":_vm.minDate,"not-after":_vm.maxDate}},'DatePicker',_vm.props,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }